import { render, staticRenderFns } from "./vat_status.vue?vue&type=template&id=2236470a"
import script from "./vat_status.vue?vue&type=script&lang=js"
export * from "./vat_status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports